import { ReadonlyURLSearchParams } from 'next/navigation';

import { QueryStringKey } from '@lib/url/queryUtils';

export const getIsUA = (searchParams: ReadonlyURLSearchParams): boolean => {
  return (
    searchParams.has(QueryStringKey.GoogleClickIdentifier) ||
    searchParams.has(QueryStringKey.FacebookClickIdentifier)
  );
};
